import type { ParagraphProps } from "@op/puck-types";

const Paragraph = ({ children }: ParagraphProps) => {
  return <div className="prose prose-neutral">{children}</div>;
};

export default Paragraph;
